import { Capacitor } from '@capacitor/core'
import consola from 'consola'
import { useRustoreUpdate } from '@features/app-update'

/**
 * Авто-инициализация RuStore In‑app Updates на старте приложения (только нативные платформы)
 */
export default defineNuxtPlugin(() => {
  const logPrefix = '[RUSTORE-PLUGIN]'
  const log = (...args: any[]) => consola.log(logPrefix, ...args)
  log("[RuStore] -1--1---")
  const config = useRuntimeConfig();
  log("[RuStore] -1--2---")
  if (!process.client) return
  log("[RuStore] -1--3---")
  if (!Capacitor.isNativePlatform()) return
  log("[RuStore] -1--4---")

  const rustore = useRustoreUpdate()
  log("[RuStore] -1--5---")
  rustore.detectBridge()
  log("[RuStore] -1--6---")
  ;(async () => {
    try {
      log("[RuStore] -1--7---")
      const ok = await rustore.init()
      log("[RuStore] -1--8---")
      if (!ok) {
        consola.warn('[RUSTORE-UPDATE]', 'Init skipped or failed')
        return
      }

      const auto = String(config.public.rustoreAutoUpdate || '').toLowerCase()
      const autoImmediate = auto === 'immediate'
      const autoFlexible = auto === 'flexible'
      const autoSilent = auto === 'silent'

      if (autoImmediate || autoFlexible || autoSilent) {
        const info = await rustore.getAppUpdateInfo()
        if (info?.available) {
          if (autoImmediate) await rustore.startUpdateImmediate()
          else if (autoFlexible) await rustore.startUpdateFlexible()
          else if (autoSilent) await rustore.startUpdateSilent()
        }
      }
    } catch (error) {
      consola.warn('[RUSTORE-UPDATE]', 'Init error', error)
    }
  })()
})


